import React, { useEffect } from "react";
import Slider from "@material-ui/core/Slider";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    sliderContainer: {
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
    icons: {
        color: theme.palette.mode === "dark" ? "#ccc" : "#555", // Ajusta cor dos ícones conforme tema
        fontSize: 20,
    },
    slider: {
        margin: "0 8px",
        width: "100%",
    },
}));

const NotificationsVolume = ({ volume, onChange }) => {
    const classes = useStyles();

    // Carregar volume do localStorage ao montar
    useEffect(() => {
        const savedVolume = localStorage.getItem("volume");
        if (savedVolume && parseFloat(savedVolume) !== volume) {
            onChange(parseFloat(savedVolume)); // Atualiza o estado global se necessário
        }
    }, [onChange, volume]);

    const handleVolumeChange = (e, value) => {
        onChange(value); // Atualiza o estado global
        localStorage.setItem("volume", value); 
    };

    return (
        <div className={classes.sliderContainer}>            
            <Slider
                value={parseFloat(volume)}
                min={0}
                max={1}
                step={0.1}
                onChange={handleVolumeChange}
                aria-labelledby="volume-slider"
                className={classes.slider}
            />            
        </div>
    );
};

export default NotificationsVolume;